var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "15%",
            visible: _vm.innerVisible,
            "append-to-body": "",
          },
          on: {
            close: _vm.close,
            "update:visible": function ($event) {
              _vm.innerVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "saoPrice" }, [
            _c("p", { staticClass: "p1" }, [
              _vm._v(_vm._s(_vm.types + "扫码")),
            ]),
            _c(
              "div",
              { staticStyle: { margin: "0.2rem 0" } },
              [_c("Qr", { attrs: { size: 150, text: _vm.wxText } })],
              1
            ),
            _c("p", { staticClass: "p2" }, [
              _vm._v("支付即同意"),
              _c("span", [_vm._v(_vm._s(_vm.types) + "用户协议")]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }